import React from 'react';
import { Chip } from '@mui/material';
import type { PurchaseOrderStatus } from '../../types/venue';

interface Props {
  status: PurchaseOrderStatus;
  size?: 'small' | 'medium';
}

const CONFIG: Record<PurchaseOrderStatus, { label: string; color: string; bg: string }> = {
  draft:              { label: 'Draft',           color: '#6e7781', bg: '#f6f8fa' },
  ordered:            { label: 'Ordered',          color: '#0969da', bg: '#dbeafe' },
  partially_received: { label: 'Part. Received',   color: '#6e40c9', bg: '#ede9fe' },
  received:           { label: 'Received',         color: '#1a7f37', bg: '#dafbe1' },
  closed:             { label: 'Closed',           color: '#9a6700', bg: '#fef9c3' },
  cancelled:          { label: 'Cancelled',        color: '#cf222e', bg: '#ffebe9' },
};

const POStatusBadge: React.FC<Props> = ({ status, size = 'small' }) => {
  const cfg = CONFIG[status] ?? { label: status, color: '#6e7781', bg: '#f6f8fa' };
  return (
    <Chip
      label={cfg.label}
      size={size}
      sx={{
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        color: cfg.color,
        backgroundColor: cfg.bg,
        border: 'none',
        height: size === 'small' ? 22 : 28,
      }}
    />
  );
};

export default POStatusBadge;
